export const ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT;
export const MAIN_APP_URL = process.env.VUE_APP_MAIN_APP_URL;
export const EMPLOYEE_APP_URL = process.env.VUE_APP_EMPLOYEE_APP_URL;
export const EMPLOYEE_MARKETING_APP_URL = process.env.VUE_APP_EMPLOYEE_MARKETING_APP_URL;
export const EXTENSION_URL = process.env.VUE_APP_EXTENSION_URL;
export const HUMANLY_MAIN_APP_URL = process.env.VUE_APP_HUMANLY_MAIN_APP_URL;

export const SEGMENT_API_KEY = process.env.VUE_APP_SEGMENT_API_KEY;
export const BEACON_KEY = process.env.VUE_APP_BEACON_KEY;

export const NEWRELIC_ACCOUNT_ID = process.env.VUE_APP_NEWRELIC_ACCOUNT_ID;
export const NEWRELIC_APPLICATION_ID = process.env.VUE_APP_NEWRELIC_APPLICATION_ID;
export const NEWRELIC_LICENSE_KEY = process.env.VUE_APP_NEWRELIC_LICENSE_KEY;
export const NEWRELIC_TRUST_KEY = process.env.VUE_APP_NEWRELIC_TRUST_KEY;
